import React from 'react';

export default function ProofOfInvestments() {
  return (
    <div>proofOfInvestments</div>
  );
}
